/**
 * Estado de autenticación — sesión SOLO en memoria por diseño (contrato §1).
 *
 * El access token vive en esta señal, nunca en localStorage ni cookies JS.
 * El refresh token es una cookie httponly gestionada 100% por el backend:
 * el frontend jamás lo lee, lo guarda ni lo envía. Tras un reload, la sesión
 * se rehidrata en silencio vía POST /auth/refresh (el navegador manda la cookie).
 */
export interface AuthState {
  username: string;
  password: string;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
  id: number | null;
  fullName: string | null;
  email: string | null;
  isSuperadmin: boolean;
  roleType: string | null;
  roleId: number | null;
  roleName: string | null;
  roleLevel: number | null;
  jti: string | null;
  familyId: string | null;
  accessToken: string | null;
}

export const initialAuthState: AuthState = {
  username: '',
  password: '',
  isAuthenticated: false,
  loading: false,
  error: null,
  id: null,
  fullName: null,
  email: null,
  isSuperadmin: false,
  roleType: null,
  roleId: null,
  roleName: null,
  roleLevel: null,
  jti: null,
  familyId: null,
  accessToken: null,
};